<template>
  <b-card class="RwvProductCard">
    <p class="text-muted small" style="float: none">
      Passendes Produkt
    </p>
    <a :href="product.link">
      <h5> {{product.name}} </h5>
    </a>
    <p>&nbsp;- {{toLocaleString(product.price) + " €"}}</p>
    <img class="productImage" :src="product.image" :alt="product.name">
    <b-button
      size="sm"
      variant="warning"
      v-if="isAuthenticated && !preview"
      :to="{ name: 'product-edit', params: { slug: product.slug } }">

      <i class="material-icons">edit</i><span>&nbsp;Bearbeiten</span>
    </b-button>
  </b-card>
</template>

<script>
export default {
  name: "RwvProductCard",
  props: {
    product: {
      type: Object,
      required: true
    },
    isAuthenticated: {
      type: Boolean,
      required: true
    },
    preview: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toLocaleString(price) {
      if (price) {
        return price.toLocaleString('de-DE', {minimumFractionDigits: 2})
      } else {
        return " - "
      }
    }
  }
}
</script>

<style lang="scss">
.RwvProductCard {
  margin: auto;
  h5 {
    float: left;
  }
  p {
    float: left;
  }
  .productImage {
    width: 100%;
    display: block;
  }
}
</style>
